// extracted by mini-css-extract-plugin
module.exports =  {"link":"EwvMnLAqjcXFRmxt8di8"};